import { CircularProgress, Link, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useLocation } from 'react-router-dom';

interface MenuItemProps {
  href?: string;
  label: string;
  progress?: number;
  /* last in the list renders a bottom border */
  last?: boolean;
  onClick?: () => void;
}

export const MenuItem = ({ href, label, progress, last = false, onClick }: MenuItemProps) => {
  const { pathname, hash } = useLocation();
  const isActive = href === `${pathname}${hash}`;
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const iconStyles = { position: 'absolute', left: theme.spacing(2) };
  let progressIcon = <></>;
  if (progress !== undefined) {
    if (progress >= 100) {
      progressIcon = <TaskAltIcon sx={iconStyles} />;
    } else {
      progressIcon = <CircularProgress variant="determinate" value={progress} size="24px" sx={{ color: theme.palette.primary.main, ...iconStyles }} />;
    }
  }
  const borderString = `1px solid ${theme.palette.primary.main}`;
  const sideBorderString = isActive ? `${theme.spacing(1)} solid ${theme.palette.primary.main}` : 0;

  return (
    <Link
      href={href}
      onClick={onClick}
      sx={{
        height: theme.spacing(6),
        borderTop: borderString,
        borderBottom: last ? borderString : 0,
        borderLeft: sideBorderString,
        borderRight: sideBorderString,
        textAlign: 'center',
        '&:hover': { background: theme.palette.menuColor },
        p: 1,
      }}
    >
      <Stack direction="row" sx={{ height: '100%', alignItems: 'center' }}>
        {progressIcon}
        <Typography
          sx={{
            width: '100%',
            '&:hover': { color: theme.palette.primary.dark },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: isSmallerScreen ? '14px' : '16px',
          }}
        >
          {label}
        </Typography>
      </Stack>
    </Link>
  );
};
